import React, {FunctionComponent, useContext, useEffect} from 'react';
import {User} from '/src/domain/shared/User';
import {ChallengeContext, ChallengeContextProps} from '/src/contexts/ChallengeContext';
import AuditResult from '/src/ui/challengeProtocol/audit/AuditResult'
import AuditSearch from '/src/ui/challengeProtocol/audit/AuditSearch';
import makeStyles from '@mui/styles/makeStyles';

interface AuditData {
    currentUser?: User;
    challengeKey: string;
}


const Audit: FunctionComponent<AuditData> = ({
                                                 currentUser,
                                                 challengeKey
                                             }) => {
    const classes = useStyles()
    const {audit} = useContext(ChallengeContext) as ChallengeContextProps

    useEffect(() => {
        if (currentUser) {
            audit(challengeKey, String(currentUser?.id))
        }
    }, [currentUser])

    return (
        <>
            {
                currentUser &&
                <div className={classes.container}>
                    <AuditSearch
                        currentUserId={currentUser?.id}
                        handleAudit={userId => {
                            audit(challengeKey, userId);
                        }}
                    />
                    <AuditResult 
                        challengeKey={challengeKey} 
                        currentUser={currentUser}
                    />
                </div>
            }
        </>
    )
}

const useStyles = makeStyles((muiTheme) => ({
    container: {
        color: muiTheme.palette.primary.main,
        fontWeight: 500,
    },
}))

export default Audit